<div class="button-back-to-top text-center">
    <button type="button"
            class="button is-primary"
            (click)="scrollTop()"
    >
      <i class="fas fa-arrow-up"></i> &nbsp;

      {{ buttonText }}
    </button>

</div>